import { UserInvitationInput } from 'admin/inputs/UserInvitationInput';
import { List, useStore } from 'react-admin';

import { UserInvitationDatagrid } from './UserInvitationDatagrid';
import { UserInvitationListAside, userInvitationStatusFilters } from './UserInvitationListAside';

export const UserInvitationList: React.FC = () => {
  const [statusFilter] = useStore('resources.userInvitations.list.statusFilter', userInvitationStatusFilters[0].filter);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const filters = [<UserInvitationInput label="E-mail" source="email" />];

  return (
    <List
      aside={<UserInvitationListAside />}
      exporter={false}
      filter={statusFilter}
      filters={filters}
      sort={{ field: 'creationTimestamp', order: 'DESC' }}
    >
      <UserInvitationDatagrid />
    </List>
  );
};
